module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/06caa78236d13412a329a8a58b8e2365.png";